import { useEffect, useState, useRef } from "react";
import chevronDown from "../../assets/vw/svg/chevron-down.svg";
import chevronUp from "../../assets/vw/svg/chevron-up.svg";

const Dropdown = ({
  menu,
  title,
  handleOptionSelected,
  itsCardsView,
  inputField,
  errors,
  required,
  disabled = false,
  extraStyle = ""
}) => {
  const [isOptionsOpen, setIsOptionsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const filtroRef = useRef();
  const [showData, setShowData] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const closeFiltro = (e) => {
        if (!filtroRef.current.contains(e.target)) {
          setIsOptionsOpen(false);
        }
      };
      window.addEventListener("mouseup", closeFiltro);
      return () => window.removeEventListener("mouseup", closeFiltro);
    }
  }, [isOptionsOpen]);

  useEffect(() => {
    const index = menu.findIndex((element) => element.props?.value === inputField || element===inputField  );
    if (index >= 0) {
      setSelectedOption(index) 
    }else {
      setSelectedOption(null)
    };
  }, [inputField]);

  function setProfileVisibility() {
    setShowData(!showData);
  }

  const toggleOptions = () => {
    setIsOptionsOpen(!isOptionsOpen);
  };


  const onclickOptionSelected = (index, option) => {
    setSelectedOption(index);
    setIsOptionsOpen(false);
    setShowData(!showData);
    if (handleOptionSelected) handleOptionSelected(option);
    if (inputField?.onChange) inputField.onChange(option);
  };

  const showSelectedOption = () => {
    if (inputField?.value) {
      return inputField.value;
    } else if (selectedOption !== null) {
      return menu[selectedOption];
    } else {
      return title;
    }
  };

  return (
    <div className={`dropdown_vw_input p-0 ${extraStyle !== "" ? extraStyle : ""}`} ref={filtroRef}>
      <div className={`containerMenu ${disabled ? "disabled_option" : ""}`}>
        
          <div
            className="btn btn-container"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            onClick={toggleOptions}
          >
            <div className="d-flex flex-row-reverse btn-arrow-container">
            <button
              type="button"
              className={`chevron_dropdown_input`}
              onClick={() => setProfileVisibility()}
              aria-expanded={showData}
            >
              { showData === false ? <img src={chevronUp} alt="before" />: <img src={chevronDown } alt="before" /> }
            </button>
            </div>
            
            <div className={`content`}> {selectedOption !== null ? showSelectedOption() : title}</div>
          </div>
        

       <ul
          className={`dropdown-menu options  ${isOptionsOpen ? "show" : ""}`}
          role="listbox"
          tabIndex={-1}
        >
          {menu.map((option, index) => (
            option !== "" && <li
              id={option}
              role="option"
              aria-selected={selectedOption === index}
              tabIndex={0}
              key={index}
              onClick={() => onclickOptionSelected(index, option)}
            >
                <label className="px-2">{option}</label>
              
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Dropdown;
